import { isLocalDevHostname } from './devAuth';

const SAMPLE_MODE_KEY = 'funding-clients-sample-mode';

/** Sample roster/details UI is available on local dev hostnames (non-production). */
export function isFundingClientsSampleUiEnabled() {
  if (process.env.NODE_ENV === 'production') return false;
  return isLocalDevHostname();
}

export function loadClientsSampleMode(defaultValue = true) {
  try {
    const raw = localStorage.getItem(SAMPLE_MODE_KEY);
    if (raw === 'false') return false;
    if (raw === 'true') return true;
  } catch {
    // ignore
  }
  return defaultValue;
}

export function saveClientsSampleMode(enabled) {
  try {
    localStorage.setItem(SAMPLE_MODE_KEY, enabled ? 'true' : 'false');
  } catch {
    // ignore
  }
}

export function hasOnlySampleClients(clients = []) {
  return clients.length > 0 && clients.every((client) => client.isSample);
}

export function hasRealClients(clients = []) {
  return clients.some((client) => !client.isSample);
}

export function filterRealFundingClients(clients = []) {
  return clients.filter((client) => !client.isSample);
}
